(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benvel-wishlist-page"] && !Shopify.designMode) return;
  try {
    
  /* Story 14.2 — Wishlist page hydration.
   *
   * Reads localStorage["benvel.wishlist.products"] +
   * localStorage["benvel.wishlist.looks"], populates tab counts, hydrates the
   * Piezas grid (one card per saved product via product JSON fetch) and the
   * Looks grid (one card per saved look via the look-card <template>).
   *
   * ARIA APG tablist:
   *   - aria-selected reflects current tab.
   *   - inactive panel is hidden via the `hidden` attribute.
   *   - keyboard: ArrowLeft / ArrowRight cycle, Home / End jump, Enter / Space
   *     activate, Tab moves into the panel.
   *
   * URL sync:
   *   - On load, ?tab=piezas|looks selects default tab.
   *   - On tab activation, history.replaceState updates the query.
   *
   * Budget: this inline block is bundled with the section; the asset stays
   * under the 4 KB gz budget (AC9). No external dependencies. No CDN.
   */
  (function () {
    'use strict';

    var root = document.currentScript
      ? document.currentScript.closest('[data-bv-wishlist-page]')
      : document.querySelector('[data-bv-wishlist-page]');
    if (!root) return;

    var PRODUCTS_KEY = 'benvel.wishlist.products';
    var LOOKS_KEY = 'benvel.wishlist.looks';

    function safeReadList(key) {
      try {
        var raw = window.localStorage.getItem(key);
        if (!raw) return [];
        var parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch (_e) {
        return [];
      }
    }

    function formatCOP(value) {
      if (typeof value !== 'number' || isNaN(value)) value = 0;
      try {
        return new Intl.NumberFormat('es-CO', {
          style: 'currency',
          currency: 'COP',
          maximumFractionDigits: 0,
        }).format(value);
      } catch (_e) {
        return '$' + Math.round(value).toLocaleString('es-CO');
      }
    }

    var labelTemplates = {
      piezas: root.querySelector('[data-bv-wishlist-tab-label="piezas"]').textContent.replace(/\d+/, '{n}'),
      looks: root.querySelector('[data-bv-wishlist-tab-label="looks"]').textContent.replace(/\d+/, '{n}'),
    };

    function updateCount(which, count) {
      var span = root.querySelector('[data-bv-wishlist-tab-label="' + which + '"]');
      if (!span) return;
      span.textContent = labelTemplates[which].replace('{n}', String(count));
    }

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bv-wishlist-tab]'));
    var panels = {
      piezas: root.querySelector('[data-bv-wishlist-panel="piezas"]'),
      looks: root.querySelector('[data-bv-wishlist-panel="looks"]'),
    };

    function activateTab(which, options) {
      options = options || {};
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-bv-wishlist-tab') === which;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      });
      Object.keys(panels).forEach(function (key) {
        var panel = panels[key];
        if (!panel) return;
        if (key === which) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      if (options.focus) {
        var active = tabs.filter(function (t) {
          return t.getAttribute('data-bv-wishlist-tab') === which;
        })[0];
        if (active) active.focus();
      }
      if (options.updateUrl !== false) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('tab', which);
          window.history.replaceState(null, '', url.toString());
        } catch (_e) {
          /* History API unavailable — fail silent. */
        }
      }
    }

    function onKeydown(event) {
      var key = event.key;
      if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End') {
        return;
      }
      event.preventDefault();
      var current = tabs.findIndex(function (t) {
        return t.getAttribute('aria-selected') === 'true';
      });
      var next = current;
      if (key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
      if (key === 'ArrowRight') next = (current + 1) % tabs.length;
      if (key === 'Home') next = 0;
      if (key === 'End') next = tabs.length - 1;
      activateTab(tabs[next].getAttribute('data-bv-wishlist-tab'), {
        focus: true,
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab.getAttribute('data-bv-wishlist-tab'));
      });
      tab.addEventListener('keydown', onKeydown);
    });

    /* Story 14.5 — unavailable-state matrix client-side helper.
     *
     * Mirrors the precedence in
     * `snippets/wishlist-saved-product-card-actions.liquid` so the
     * client-side surrogate cards (Story 14.2's flow) get the same
     * unavailable-state branching as a server-rendered card would.
     *
     * unavailableLog: a sibling localStorage key
     * `benvel.wishlist.unavailable_log` storing `{ productId+variantId: ISO }`
     * timestamps the FIRST time a saved variant was observed unavailable.
     * Back-in-stock is "was previously unavailable AND now available".
     * Keeping it in a sibling key preserves the v1.5 BU metafield mirror
     * clean (Story 14.1 schema reads only the canonical key).
     */
    var UNAVAILABLE_LOG_KEY = 'benvel.wishlist.unavailable_log';

    function readUnavailableLog() {
      try {
        var raw = window.localStorage.getItem(UNAVAILABLE_LOG_KEY);
        if (!raw) return {};
        var parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : {};
      } catch (_e) {
        return {};
      }
    }

    function writeUnavailableLog(log) {
      try {
        window.localStorage.setItem(UNAVAILABLE_LOG_KEY, JSON.stringify(log));
      } catch (_e) {
        /* quota / disabled storage — silent skip */
      }
    }

    function logKey(productId, variantId) {
      return String(productId) + ':' + String(variantId);
    }

    /* Compute the action state per saved entry + fetched product JSON.
     * Returns one of: sold_out, size_out, low_stock, back_in_stock, default. */
    function computeActionState(entry, productJson, log) {
      if (!productJson || !Array.isArray(productJson.variants)) {
        return { state: 'default', variant: null };
      }
      var variant = null;
      if (entry.variantId) {
        for (var i = 0; i < productJson.variants.length; i++) {
          if (String(productJson.variants[i].id) === String(entry.variantId)) {
            variant = productJson.variants[i];
            break;
          }
        }
      }
      if (!variant) {
        variant =
          productJson.variants.find(function (v) {
            return v.available;
          }) || productJson.variants[0];
      }

      var lkey = logKey(entry.productId, variant ? variant.id : '');
      var wasUnavailable = !!log[lkey];

      if (!variant || variant.available === false) {
        /* Log this variant as unavailable so a later in-stock observation
         * triggers the back-in-stock branch. */
        if (!wasUnavailable) {
          log[lkey] = new Date().toISOString();
        }
        return { state: 'sold_out', variant: variant };
      }

      /* Variant is available. Did the buyer save a specific size? */
      if (entry.size) {
        var savedSizeVariant = productJson.variants.find(function (v) {
          if (!v.options || !v.options.length) return false;
          return v.options.some(function (opt) {
            return String(opt).toLowerCase() === String(entry.size).toLowerCase();
          });
        });
        if (savedSizeVariant && savedSizeVariant.available === false) {
          return { state: 'size_out', variant: variant };
        }
      }

      /* Back-in-stock — variant available now, was unavailable before. */
      if (wasUnavailable) {
        /* Keep the log entry until the buyer dismisses or removes; the
         * back-in-stock chip stays until they act on it. */
        return { state: 'back_in_stock', variant: variant };
      }

      /* Low-stock honest-rule (mirrors benvel-stock-chip.liquid). */
      if (
        variant.inventory_management === 'shopify' &&
        variant.inventory_policy === 'deny' &&
        typeof variant.inventory_quantity === 'number' &&
        variant.inventory_quantity > 0 &&
        variant.inventory_quantity <= 3
      ) {
        return {
          state: 'low_stock',
          variant: variant,
          lowStockQty: variant.inventory_quantity,
        };
      }

      return { state: 'default', variant: variant };
    }

    function buildSimilarUrl(entry, productJson) {
      /* Path A — product.metafields.benvel.alternative_collection_handle.
       * /products/{handle}.js does NOT include metafields by default. We
       * embed the metafield via `<script type="application/json"
       * data-bv-wishlist-alt-map>` from the section schema if present, or
       * leave Path B as the fallback. The graceful path is always usable. */
      if (productJson && productJson.benvel_alt_collection) {
        return '/collections/' + productJson.benvel_alt_collection;
      }
      /* Path B′ — graceful fallback when Story 18.7 not yet shipped. */
      var stem = (entry.handle || '').split('-')[0].replace(/[^a-z0-9]/gi, '');
      if (stem) {
        return '/collections/all?q=' + encodeURIComponent(stem);
      }
      return '/collections/all';
    }

    function applyActionsToCell(li, entry, result, productJson, t) {
      var tmpl = document.getElementById('bv-wishlist-card-actions-template');
      if (!tmpl || !tmpl.content) return;
      if (result.state === 'default') return;

      var node = tmpl.content.firstElementChild.cloneNode(true);
      node.classList.add('bv-wishlist-card-actions--' + result.state.replace(/_/g, '-'));
      node.setAttribute('data-bv-wishlist-action-state', result.state);
      node.setAttribute('data-bv-wishlist-product-id', String(entry.productId));
      node.setAttribute('data-bv-wishlist-variant-id', String(result.variant ? result.variant.id : ''));

      var reasonEl = node.querySelector('[data-bv-wishlist-action-reason]');
      var chipEl = node.querySelector('[data-bv-wishlist-action-chip]');
      var notifyBtn = node.querySelector('[data-bv-bis-trigger]');
      var similarLink = node.querySelector('[data-bv-wishlist-similar]');

      /* The locale strings come from the Liquid-processed JSON island with
       * the canonical pluralized count token in them. We re-interpolate
       * client-side; the token marker is reconstructed at runtime so this
       * javascript-tag block stays Liquid-free (per
       * StaticStylesheetAndJavascriptTags theme-check rule). */
      var COUNT_TOKEN = '{' + '{ count }' + '}';

      if (result.state === 'low_stock') {
        if (reasonEl) reasonEl.remove();
        if (chipEl) {
          chipEl.hidden = false;
          chipEl.setAttribute('data-quantity', String(result.lowStockQty));
          var lowKey = result.lowStockQty === 1 ? 'stock_chip.low.body.one' : 'stock_chip.low.body.other';
          chipEl.textContent = (t[lowKey] || 'Solo quedan ' + result.lowStockQty)
            .split(COUNT_TOKEN)
            .join(String(result.lowStockQty));
          chipEl.setAttribute(
            'aria-label',
            (t['stock_chip.low.aria_label.' + (result.lowStockQty === 1 ? 'one' : 'other')] || '')
              .split(COUNT_TOKEN)
              .join(String(result.lowStockQty)),
          );
        }
      } else {
        if (chipEl) chipEl.remove();
        var reasonKey = 'wishlist.unavailable.' + result.state;
        var reasonText = t[reasonKey] || '';
        if (reasonEl) {
          if (reasonText) {
            reasonEl.textContent = reasonText;
            reasonEl.id = 'bv-wishlist-reason-' + entry.productId;
            reasonEl.hidden = false;
          } else {
            reasonEl.remove();
          }
        }
      }

      if (result.state === 'sold_out' || result.state === 'back_in_stock') {
        if (notifyBtn) {
          notifyBtn.hidden = false;
          notifyBtn.id = 'bv-wishlist-notify-' + entry.productId;
          if (result.variant) {
            notifyBtn.setAttribute('data-bv-bis-trigger', String(result.variant.id));
          }
          notifyBtn.setAttribute('data-bv-bis-product-handle', entry.handle || '');
          notifyBtn.setAttribute('data-bv-bis-product-title', entry.title || '');
          var rid = 'bv-wishlist-reason-' + entry.productId;
          if (reasonEl && !reasonEl.parentNode) {
            /* reason was removed above — skip aria-describedby */
          } else {
            notifyBtn.setAttribute('aria-describedby', rid);
          }
        }
      } else if (notifyBtn) {
        notifyBtn.remove();
      }

      if (result.state === 'size_out' || result.state === 'sold_out') {
        if (similarLink) {
          similarLink.hidden = false;
          similarLink.id = 'bv-wishlist-similar-' + entry.productId;
          var href = buildSimilarUrl(entry, productJson);
          similarLink.setAttribute('href', href);
          similarLink.setAttribute(
            'data-bv-wishlist-has-alt',
            productJson && productJson.benvel_alt_collection ? 'true' : 'false',
          );
          similarLink.setAttribute('data-bv-wishlist-product-id', String(entry.productId));
          if (result.state === 'size_out' && reasonEl && reasonEl.parentNode) {
            similarLink.setAttribute('aria-describedby', 'bv-wishlist-reason-' + entry.productId);
          }
        }
      } else if (similarLink) {
        similarLink.remove();
      }

      li.appendChild(node);
    }

    /* Read the localized strings the template host needs in order to
     * populate text content from JS. The Shopify javascript-tag does NOT
     * process Liquid, so we read the JSON island authored in the section
     * body (id="bv-wishlist-card-i18n"). */
    var i18nTbl = (function () {
      try {
        var island = document.getElementById('bv-wishlist-card-i18n');
        if (island && island.textContent) {
          return JSON.parse(island.textContent);
        }
      } catch (_e) {
        /* Malformed JSON — fall through to empty table; UI degrades to
         * blank reason text rather than throwing. */
      }
      return {};
    })();

    /* Fetch /products/{handle}.js — Shopify ships this endpoint on every
     * storefront. We cache responses for the duration of the page to avoid
     * re-fetching when the wishlist re-hydrates from storage events. */
    var productJsonCache = {};
    function fetchProductJson(handle) {
      if (!handle) return Promise.resolve(null);
      if (productJsonCache[handle]) return Promise.resolve(productJsonCache[handle]);
      return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (json) {
          productJsonCache[handle] = json;
          return json;
        })
        .catch(function () {
          return null;
        });
    }

    function renderProductCards(products) {
      var grid = root.querySelector('[data-bv-wishlist-grid="products"]');
      if (!grid) return;
      grid.innerHTML = '';
      var log = readUnavailableLog();
      products.forEach(function (entry) {
        var handleOrId = entry.handle || entry.productId;
        if (!handleOrId) return;
        var li = document.createElement('li');
        li.className = 'benvel-wishlist__product-cell';
        li.setAttribute('data-product-id', String(entry.productId));
        grid.appendChild(li);

        if (entry.handle || entry.productUrl) {
          var anchor = document.createElement('a');
          anchor.href = entry.productUrl || '/products/' + entry.handle;
          anchor.className = 'benvel-wishlist__product-link';
          anchor.textContent = entry.title || handleOrId;
          li.appendChild(anchor);
        }

        /* Story 14.5 — fetch product JSON, compute the unavailable-state
         * matrix, inject the actions row beneath the card. Fail-silent
         * if /products/{handle}.js is not reachable — the card still
         * renders as a title/anchor (Story 14.2 baseline). */
        if (entry.handle) {
          fetchProductJson(entry.handle).then(function (json) {
            var result = computeActionState(entry, json, log);
            applyActionsToCell(li, entry, result, json, i18nTbl);
          });
        }
      });
      /* Persist the unavailable_log additions after the synchronous loop;
       * the async fetches may further mutate it but writeUnavailableLog is
       * called again from the post-fetch handlers via a debounced write. */
      writeUnavailableLog(log);
    }

    function renderLookCards(looks) {
      var grid = root.querySelector('[data-bv-wishlist-grid="looks"]');
      var tmpl = document.getElementById('bv-wishlist-look-card-template');
      if (!grid || !tmpl) return;
      grid.innerHTML = '';
      looks.forEach(function (look) {
        var node = tmpl.content.firstElementChild.cloneNode(true);
        node.setAttribute('data-look-id', String(look.lookId || ''));
        node.setAttribute('aria-label', (look.title || 'Look') + ' — ' + formatCOP(look.totalPrice));
        var thumbsHost = node.querySelector('.bv-wishlist-look-card__thumbs');
        var refs = Array.isArray(look.productRefs) ? look.productRefs : [];
        refs.slice(0, 5).forEach(function (ref) {
          var img = document.createElement('img');
          img.className = 'bv-wishlist-look-card__thumb';
          img.loading = 'lazy';
          img.width = 80;
          img.height = 80;
          img.alt = ref.title || '';
          img.src = ref.image || '';
          thumbsHost.appendChild(img);
        });
        var titleEl = node.querySelector('[data-title]');
        if (titleEl) titleEl.textContent = look.title || '';
        var occEl = node.querySelector('[data-occasion]');
        if (occEl) occEl.textContent = look.occasion || '';
        var totalEl = node.querySelector('[data-total]');
        if (totalEl) totalEl.textContent = formatCOP(look.totalPrice);
        node.addEventListener('click', function () {
          document.dispatchEvent(
            new CustomEvent('benvel:wishlist-open-look', {
              detail: { lookId: look.lookId },
            }),
          );
        });
        node.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            node.click();
          }
        });
        grid.appendChild(node);
      });
    }

    function hydrate() {
      var products = safeReadList(PRODUCTS_KEY);
      var looks = safeReadList(LOOKS_KEY);
      updateCount('piezas', products.length);
      updateCount('looks', looks.length);

      if (products.length === 0 && looks.length === 0) {
        root.setAttribute('data-bv-wishlist-state', 'empty');
        return;
      }
      root.setAttribute('data-bv-wishlist-state', 'populated');

      renderProductCards(products);
      renderLookCards(looks);
    }

    /* Default-tab selection — AC5. */
    function applyDeepLink() {
      try {
        var params = new URLSearchParams(window.location.search);
        var requested = params.get('tab');
        if (requested === 'piezas' || requested === 'looks') {
          activateTab(requested, { updateUrl: false });
        }
      } catch (_e) {
        /* URL API unavailable — keep server-side default. */
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        applyDeepLink();
        hydrate();
      });
    } else {
      applyDeepLink();
      hydrate();
    }

    /* Listen for wishlist mutations from the heart-button (Story 14.1) so the
     * page re-hydrates when a buyer removes a saved item while on the
     * Wishlist page itself. The heart-button dispatches a custom event;
     * absent that, the `storage` event covers cross-tab edits. */
    window.addEventListener('storage', function (event) {
      if (event.key === PRODUCTS_KEY || event.key === LOOKS_KEY) {
        hydrate();
      }
    });
    document.addEventListener('benvel:wishlist-saved', hydrate);
    document.addEventListener('benvel:wishlist-removed', hydrate);
    /* Story A5-S3 — re-hydrate after the server wishlist union-merge. */
    document.addEventListener('benvel:wishlist-server-merged', hydrate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
